import { FilterForm } from '@/components/common/Filter'
import {
  type CardFilterPartialType,
  type CardFilterSlugType,
  type CardFilterType,
  isCardFilterBooleanPartialType,
  isCardFilterColorsPartialType,
  isCardFilterNumberPartialType,
  isCardFilterSearchPartialType,
  isCardFilterSelectPartialType,
  isCardFilterType,
  withCardFilterDefaults,
} from '@/defs/cardFilters'

import { optionGroups } from '../GalleryCardFilters'

import { GalleryCardFiltersFormBoolean } from './GalleryCardFiltersFormBoolean/GalleryCardFiltersFormBoolean'
import { GalleryCardFiltersFormColors } from './GalleryCardFiltersFormColors/GalleryCardFiltersFormColors'
import { GalleryCardFiltersFormNumber } from './GalleryCardFiltersFormNumber/GalleryCardFiltersFormNumber'
import { GalleryCardFiltersFormSearch } from './GalleryCardFiltersFormSearch/GalleryCardFiltersFormSearch'
import { GalleryCardFiltersFormSelect } from './GalleryCardFiltersFormSelect/GalleryCardFiltersFormSelect'

type Props = {
  cardFilter: CardFilterPartialType
  onDelete: () => void
  onSubmit: (f: CardFilterType) => void
  onUpdate: (f: CardFilterPartialType) => void
}

export const GalleryCardFiltersForm = ({ cardFilter, onDelete, onSubmit: onSubmitProp, onUpdate }: Props) => {
  const invalid = !isCardFilterType(cardFilter)

  const onSubmit = () => {
    if (isCardFilterType(cardFilter)) onSubmitProp(cardFilter)
  }

  const onSelectOption = (slug: CardFilterSlugType) => {
    onUpdate(withCardFilterDefaults(slug, cardFilter))
  }

  const formElement = isCardFilterBooleanPartialType(cardFilter) ? (
    <GalleryCardFiltersFormBoolean cardFilter={cardFilter} onDelete={onDelete} onSubmit={onSubmitProp} />
  ) : isCardFilterColorsPartialType(cardFilter) ? (
    <GalleryCardFiltersFormColors cardFilter={cardFilter} onUpdate={onUpdate} />
  ) : isCardFilterNumberPartialType(cardFilter) ? (
    <GalleryCardFiltersFormNumber cardFilter={cardFilter} onUpdate={onUpdate} />
  ) : isCardFilterSearchPartialType(cardFilter) ? (
    <GalleryCardFiltersFormSearch cardFilter={cardFilter} onUpdate={onUpdate} />
  ) : isCardFilterSelectPartialType(cardFilter) ? (
    <GalleryCardFiltersFormSelect cardFilter={cardFilter} onUpdate={onUpdate} />
  ) : null

  return (
    <FilterForm
      invalid={invalid}
      onDelete={onDelete}
      onSelectOption={onSelectOption}
      onSubmit={onSubmit}
      optionGroups={optionGroups}
      value={cardFilter.slug}
    >
      {formElement}
    </FilterForm>
  )
}
